// extracted by mini-css-extract-plugin
export default {"wrapper":"ImportSchoolsToRanking_wrapper__TWtOQ","actions":"ImportSchoolsToRanking_actions__Qb4Dd","button":"ImportSchoolsToRanking_button__jWcYP"};